import { inject, Injectable } from '@angular/core';
import { AppConfig, APP_CONFIG } from './app-config';

/**
 * Runtime configuration accessor (T-061, Tech plan §2.2/§9). Wraps the bootstrap
 * {@link AppConfig} behind stable getters so components never import the environment
 * directly, and exposes a `load()` hook for future server-delivered runtime config.
 */
@Injectable({ providedIn: 'root' })
export class ConfigService {
  private readonly config = inject(APP_CONFIG);
  private loaded = false;

  get apiBaseUrl(): string {
    return this.config.apiBaseUrl;
  }

  get apiScopes(): string[] {
    return this.config.auth.apiScopes;
  }

  get production(): boolean {
    return this.config.production;
  }

  get appInsightsConnectionString(): string {
    return this.config.appInsights.connectionString;
  }

  get snapshot(): AppConfig {
    return this.config;
  }

  get isLoaded(): boolean {
    return this.loaded;
  }

  /** Resolves runtime configuration at bootstrap (currently the build-time snapshot). */
  async load(): Promise<AppConfig> {
    this.loaded = true;
    return this.config;
  }
}
